export default __webpack_public_path__ + "static/media/edited-icon.9847a709.svg";